import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Button} from "primereact/button";
import {OverlayPanel} from "primereact/overlaypanel";
import axios from "axios"; import Cookies from "js-cookie";
import moment from "moment";

import HelpComponent from "../HelpComponent";
import _FM_BerthShowComponent from "../_FM_berth/_FM_BerthShowComponent";
import {Badge} from "primereact/badge";

const _FM_UnitShowComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id,action, entity} = useParams();
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const opb = useRef(null);

  useEffect(() => {
    if (id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "residential-unit/" + id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  }, [window.App.state.rerenderUnitShow, window.App.state.rerenderBerthList])

  return (
    <>
      <div className={"p-grid p-mt-3"}>
        <div className={"p-col p-col-align-center"}>
          <h2 className={"p-m-0"}>
        {formData.name || t('unit_show')}
        {/*{formData.is_ready === true ? (*/}
        {/*  <Badge severity="success" style={{height: '8px', width: '8px', minWidth: '8px', position: 'relative', top: '-10px', left: '5px'}}></Badge>*/}
        {/*) : (*/}
        {/*  <Badge severity="danger"  style={{height: '8px', width: '8px', minWidth: '8px', position: 'relative', top: '-10px', left: '5px'}}></Badge>*/}
        {/*)}*/}
          </h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          <Button type="button" aria-label={t('edit')}
                  icon={"pi pi-pencil"}
                  onClick={() => {
                    navigate('/unit/')
                    setTimeout(() => {
                      navigate('/unit/update/' + id)
                    }, 500)
                  }}
                  className="p-button-warning p-ml-2">
          </Button>
          <Button type="button"
                  icon={"pi pi-times"}
                  onClick={() => {
                    navigate(-1)
                  }}
                  className="p-button-secondary close p-ml-2">
          </Button>
        </div>
      </div>
      <div className={"p-grid"}>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('accommodation')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {formData?.accommodation?.name}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('created_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('updated_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
      </div>
      <Panel className={"p-mt-3"}>
        {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
        <HelpComponent type={"show_box"}/>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-12"}>
            <div className="p-field p-fluid">
              <label htmlFor="residential_category">{t('residential_category')}</label>
              <span className="p-d-block p-text-bold">
                <i className={"pi pi-window-maximize"}
                   onClick={(e) => {
                     navigate('/unit/' + action + '/' + id +'?update=category&categoryId=' + formData.id)
                   }}
                ></i>
                &nbsp;
                {formData.residential_category?.name}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="number_of_single_beds">{t('number_of_single_beds')}</label>
              <span className="p-d-block p-text-bold">
                {formData.number_of_single_beds}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="number_of_double_beds">{t('number_of_double_beds')}</label>
              <span className="p-d-block p-text-bold">
                {formData.number_of_double_beds}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="number_of_extra_beds">{t('number_of_extra_beds')}</label>
              <span className="p-d-block p-text-bold">
                {formData.number_of_extra_beds}
              </span>
            </div>
          </div>
        </div>
      </Panel>
      {formData.berths && formData.berths[0] &&
        <>
          <Panel className={"p-mt-3"}>
            <h3 className={"p-mt-0"}>{t('berths')}</h3>
            <table className={"w-100 p-datatable-table table-striped"} cellPadding={0} cellSpacing={0} border={0}>
              {formData.berths?.map((item, index) => {
                return (
                  <>
                    <tr>
                      <td>
                        <i className={"pi pi-window-maximize"}
                           onClick={(e) => {
                             navigate('/unit/' + action + '/' + id + '?update=berth&berthId='  + item.id)
                           }}
                        ></i>
                        &nbsp;
                        {item.name}
                      </td>
                    </tr>
                  </>
                )
              })}
            </table>
          </Panel>
        </>
      }
    </>
  )
}
export default withTranslation('common')(_FM_UnitShowComponent);
